import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import request from "./request";
export function changeSystemLanguage(_x) { return _changeSystemLanguage.apply(this, arguments); }
function _changeSystemLanguage() {
    _changeSystemLanguage = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(language) {
        var _languageMap$language;
        var languageMap, resp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        localStorage.setItem("gatsby-i18next-language", language); // const language = localStorage.getItem("gatsby-i18next-language") ?? "hk";
                        languageMap = { en: "en_US", hk: "zh_HK", cn: "zh_CN" };
                        _context.next = 4;
                        return request.post("/api/v1/quotation/i18n/changeLanguage", { useSubmitTime: true, isRedirect: "0", request_locale: (_languageMap$language = languageMap[language]) !== null && _languageMap$language !== void 0 ? _languageMap$language : language });
                    case 4:
                        resp = _context.sent;
                        return _context.abrupt("return", resp.data);
                    case 6:
                    case "end": return _context.stop();
                }
            }
        }, _callee);
    }));
    return _changeSystemLanguage.apply(this, arguments);
}
